import URI from 'urijs';

class SafeRouter {
    event = typeof window !== 'undefined' && new CustomEvent('route');

    push(url: string) {
        const changingRoute = URI(url).pathname() !== window.location.pathname;

        if (changingRoute) {
            window.location.href = url;
        } else {
            window.history.replaceState(null, document.title, url);
        }
        // @ts-ignore
        window.dispatchEvent(this.event);
    }

    uri() {
        // separate out so this can be more easily mocked
        return URI();
    }

    setQuery(query: string, value?: string) {
        const uri = this.uri();
        let updated = false;
        if (value) {
            uri.setQuery(query, value);
            updated = true;
        } else if (uri.hasQuery(query)) {
            uri.removeQuery(query);
            updated = true;
        }

        if (updated) {
            const url = uri.toString();
            this.push(url);
        }
    }

    setQueries(...queries: [string, string?][]) {
        const uri = this.uri();
        let updated = false;
        queries.forEach(q => {
            if (q[1]) { // if value is falsy, remove it
                uri.setQuery(q[0], q[1]);
                updated = true;
            } else if (uri.hasQuery(q[0])) {
                uri.removeQuery(q[0]);
                updated = true;
            }
        });

        if (updated) {
            const url = uri.toString();
            this.push(url);
        }
    }

    getUrlWithQueries(...queries: [string, string?][]) {
        const uri = this.uri();
        queries.forEach(q => {
            if (q[1]) { // if value is falsy, remove it
                uri.setQuery(q[0], q[1]);
            } else if (uri.hasQuery(q[0])) {
                uri.removeQuery(q[0]);
            }
        });
        return uri.toString();
    }
}

export default new SafeRouter();
